import React, { useEffect, useState } from 'react';
import { Trash2, Download, Mail, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { useLang, tx } from '../i18n/LanguageContext';

const NewsletterManager = () => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get('/admin/newsletter').then(({ data }) => setItems(data || [])).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    await api.delete(`/admin/newsletter/${id}`);
    setItems(xs => xs.filter(x => x.id !== id));
    toast.success(L('تم الحذف', 'Deleted'));
  };

  const exportCsv = () => {
    const csv = ['email,date', ...items.map(x => `${x.email},${(x.created_at || '').slice(0, 10)}`)].join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
    a.download = 'newsletter-subscribers.csv';
    a.click();
  };

  if (loading) return <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-blue-600" /></div>;

  return (
    <div data-testid="newsletter-manager" className="rounded-2xl bg-white border border-slate-200 p-5 sm:p-6">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div>
          <h3 className="font-extrabold text-slate-900 text-lg">{L('المشتركون في نشرة المقالات', 'Articles newsletter subscribers')}</h3>
          <p className="text-slate-500 text-sm" data-testid="newsletter-count">{items.length} {L('مشترك', 'subscribers')}</p>
        </div>
        <button data-testid="newsletter-export-btn" onClick={exportCsv} disabled={!items.length}
          className="inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white text-sm font-bold transition-colors">
          <Download className="w-4 h-4" />{L('تصدير CSV', 'Export CSV')}
        </button>
      </div>
      {items.length === 0 ? (
        <div className="text-center text-slate-500 py-10">{L('لا يوجد مشتركون بعد', 'No subscribers yet')}</div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {items.map(x => (
            <li key={x.id} data-testid={`newsletter-row-${x.id}`} className="flex items-center gap-3 py-3">
              <Mail className="w-4 h-4 text-blue-500 shrink-0" />
              <span className="flex-1 min-w-0 truncate text-slate-800 text-sm" dir="ltr">{x.email}</span>
              <span className="text-xs text-slate-400" dir="ltr">{(x.created_at || '').slice(0, 10)}</span>
              <button data-testid={`newsletter-delete-${x.id}`} onClick={() => remove(x.id)} className="p-2 rounded-lg text-rose-500 hover:bg-rose-50 transition-colors">
                <Trash2 className="w-4 h-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NewsletterManager;
